import _last from 'lodash/last';
import _split from 'lodash/split';
import jquery from 'jquery';
import EventBus from '@/event-bus';

var SPLIT_LIMIT = 3;

/**
 * @description
 * Делаем магию с iframe удачного посещения
 *
 * @param {String} url - url страницы успешного заказа
 *
 * @return {void}
 */
function visitSuccessful(url) {
  var _iframe = jquery('<iframe width="0" height="0"></iframe>');
  const _order_id = _last(_split(url, '/', SPLIT_LIMIT));

  _iframe
    .attr('src', '/orders/successful?id=' + _order_id)
    .appendTo('body')
    .on('load', function() {
      return jquery(this).remove();
    });
}

/**
 * @description
 * Перекидываем на страницу удачного заказа
 *
 * @param {String} url - url страницы успешного заказа
 * @fires before_submit:insales:quick_checkout
 *
 * @return {void}
 */
function visitShow(url) {
  EventBus.publish('before_submit:insales:quick_checkout');
  window.location.replace(url);
}

/**
 * @memberof module:ajaxAPI/checkout
 * @alias quick
 *
 * @description
 * Оформление заказа
 *
 * @param {Object} formData - объект сериализованной формы
 *
 * @return {$.ajax} - jQuery.Promise
 *
 * @example
 * ajaxAPI.checkout.quick(form.serialize())
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */
export default function(formData) {
  var result = jquery.Deferred();

  const url = formData.oneClickBasketPath
    ? '/quick_checkout.json'
    : '/orders/create_with_quick_checkout.json';

  formData.pid = 1;
  formData.dataType = 'json';
  formData.type = 'POST';
  jquery.ajax(url, formData)
    .done(function(response) {
      response.withoutCart = formData.withoutCart;
      response.fakeOrder = formData.fakeOrder;
      response.fakeOrderName = formData.fakeOrderName;

      if (response.result == 'ok' && !response.show_thank_you_page) {
        visitSuccessful(response.location);

        result.resolve(response);
      } else if (response.result == 'ok' && response.show_thank_you_page) {
        visitShow(response.location);
      } else {
        result.reject(response);
      }
    })
    .fail(function(response) {
      result.reject(response);
    });

  return result.promise();
}
